exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-aggregate[data-v-3e34e97b]{background:#fafafa;line-height:26px;border-radius:10px}", ""]);

// exports
